//@flow
import template1Horizontal from './img-horizontal/template1.png';
import template2Horizontal from './img-horizontal/template2.png';
import template3Horizontal from './img-horizontal/template3.png';
import template4Horizontal from './img-horizontal/template4.png';
import template5Horizontal from './img-horizontal/template5.png';

import template1Vertical from './img-vertical/template1.png';
import template2Vertical from './img-vertical/template2.png';
import template3Vertical from './img-vertical/template3.png';
import template4Vertical from './img-vertical/template4.png';
import template5Vertical from './img-vertical/template5.png';
import template6Vertical from './img-vertical/template6.png';

export const imagesHorizontal = [
  {
    logo: {
      position: [75, 15],
      maxSize: [150, 70],
    },
    domain: {
      position: [145, 220],
      style: {
        fontSize: 80,
        fontFamily: 'Satoshi',
        color: '#55556D',
        textAlign: 'center',
      },
      maxLength: 32,
      newFontSize: 74,
      space: 9,
    },
    backgroundImage: template1Horizontal,
  },
  {
    logo: {
      position: [10, 10],
      maxSize: [110, 70],
    },
    domain: {
      position: [198, 88],
      style: {
        fontSize: 49,
        fontFamily: 'Satoshi',
        color: '#55556D',
        textAlign: 'center',
      },
      maxLength: 32,
      newFontSize: 54,
      space: 7,
    },
    backgroundImage: template2Horizontal,
  },
  {
    logo: {
      position: [189, 7],
      maxSize: [100, 67],
    },
    domain: {
      position: [18, 76],
      style: {
        fontSize: 65,
        fontFamily: 'Satoshi',
        color: 'white',
        textAlign: 'left',
      },
      maxLength: 32,
      newFontSize: 68,
      space: 7,
    },
    backgroundImage: template3Horizontal,
  },
  {
    logo: {
      position: [72, 48],
      maxSize: [150, 64],
    },
    domain: {
      position: [148, 210],
      style: {
        fontSize: 50,
        fontFamily: 'Satoshi',
        color: '#55556D',
        textAlign: 'center',
      },
      maxLength: 30,
      newFontSize: 50,
      space: 6,
    },
    backgroundImage: template4Horizontal,
  },
  {
    logo: {
      position: [128, 8],
      maxSize: [160, 45],
    },
    domain: {
      position: [202, 137],
      style: {
        fontSize: 62,
        fontFamily: 'Satoshi',
        color: '#473B3B',
        textAlign: 'center',
      },
      maxLength: 27,
      newFontSize: 60,
      space: 8,
    },
    backgroundImage: template5Horizontal,
  },
];

export const imagesVertical = [
  {
    logo: {
      position: [58, 25],
      maxSize: [200, 100],
    },
    domain: {
      position: [149, 360],
      style: {
        fontSize: 82,
        fontFamily: 'Satoshi',
        color: '#55556D',
        textAlign: 'center',
      },
      maxLength: 31,
      newFontSize: 92,
      space: 15,
    },
    backgroundImage: template1Vertical,
  },
  {
    logo: {
      position: [44, 14],
      maxSize: [220, 60],
    },
    domain: {
      position: [149, 172],
      style: {
        fontSize: 70,
        fontFamily: 'Satoshi',
        color: '#55556D',
        textAlign: 'center',
      },
      maxLength: 32,
      newFontSize: 80,
      space: 8,
    },
    backgroundImage: template2Vertical,
  },
  {
    logo: {
      position: [160, 130],
      maxSize: [130, 100],
    },
    domain: {
      position: [20, 105],
      style: {
        fontSize: 73,
        fontFamily: 'Satoshi',
        color: 'white',
        textAlign: 'left',
      },
      maxLength: 33,
      newFontSize: 85,
      space: 10,
    },
    backgroundImage: template3Vertical,
  },
  {
    logo: {
      position: [70, 65],
      maxSize: [160, 95],
    },
    domain: {
      position: [148, 377],
      style: {
        fontSize: 77,
        fontFamily: 'Satoshi',
        color: '#55556D',
        textAlign: 'center',
      },
      maxLength: 30,
      newFontSize: 76,
      space: 10,
    },
    backgroundImage: template4Vertical,
  },
  {
    logo: {
      position: [59, 22],
      maxSize: [182, 132],
    },
    domain: {
      position: [148, 346],
      style: {
        fontSize: 73,
        fontFamily: 'Satoshi',
        color: '#473B3B',
        textAlign: 'center',
      },
      maxLength: 32,
      newFontSize: 85,
      space: 8,
    },
    backgroundImage: template5Vertical,
  },
  {
    logo: {
      position: [96, 310],
      maxSize: [130, 100],
    },
    domain: {
      position: [146, 272],
      style: {
        fontSize: 75,
        fontFamily: 'Satoshi',
        color: '#2A2525',
        textAlign: 'center',
      },
      maxLength: 32,
      newFontSize: 85,
      space: 8,
    },
    backgroundImage: template6Vertical,
  },
];
